module.exports = __webpack_public_path__ + "img/mars.f27ce151.svg";